import { Permissions } from "../Permissions/features"

export const DashboardOptions = [
    {
        value: "Door-to-Door",
        slag: 1,
        Permission: Permissions.DDS_DS,
        link: '/dds-dashboard',
        linkSlags: ['/dds-dashboard']
    },
    {
        value: "Instore",
        slag: 2,
        Permission: Permissions.INSTORE_DS,
        link: "/in-store-dashboard",
        linkSlags: ['/in-store-dashboard']

    },
    // {
    //     value: "Out-of-Home",
    //     slag: 3
    // },
    {
        value: "Supervisor Performance",
        slag: 4,
        link: '/supervisor-performance-dashboard',
        Permission: Permissions.SUP_DS,
        linkSlags: ['/supervisor-performance-dashboard', '/team-accumulated-dashboard', '/customer-data-dashboard']
    },
]

export const ActivityTypeEnum = {
    DTD: 1,
    INSTORE: 2,
    OUTOFHOMEMONITORING: 3,
    SUPERVISORPERFORMANCE: 4,
}